import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
export default function ClaimerDataPreviewSeniorOfficer(_ref) {
  let {
    aifReportData
  } = _ref;
  const {
    aif_model
  } = aifReportData;
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-dark text-dark"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0"
  }, "Senior Officer")), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Name:"), " ", aif_model.senior_officer.name.first_name, " ", aif_model.senior_officer.name.last_name), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Role:"), " ", aif_model.senior_officer.role)), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Email:"), " ", aif_model.senior_officer.email), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Phone:"), " ", aif_model.senior_officer.phone)))));
}